<div class="container" [style]="containerStyle" [class.container-no-label]="hideLabel">
  <w-field-label [label]="label" *ngIf="!hideLabel && label" class="label"></w-field-label>
  <div>
    <div class="content" [class.content-no-label]="hideLabel">
      <ng-content></ng-content>
    </div>
  </div>
</div>
